export const task = {
  lessons: { total_count: 6, watched_count: 0 },
  topic: {
    name: "Evolução",
    parent: {
      name: "Biologia",
      position: 1,
      slug: "biologia",
      group: { name: "Ciências Exatas", position: 0, slug: "ciencias-exatas" }
    }
  },
  questions: { answered_count: 0, total_count: 7 },
  slug: "evolucao",
  status: "pending"
};
